import { render, staticRenderFns } from "./FramePath.vue?vue&type=template&id=7e20c722&scoped=true&lang=pug"
import script from "./FramePath.vue?vue&type=script&lang=js"
export * from "./FramePath.vue?vue&type=script&lang=js"
import style0 from "./FramePath.vue?vue&type=style&index=0&id=7e20c722&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20c722",
  null
  
)

export default component.exports